<div class="product-img-wrapper" [style.width]="width" [style.height]="height">
    <img *ngIf="imageURL" [src]="imageURL" [alt]="alt" class="responsive-img" loading="lazy" />
</div>